/**
 * Hook para obtener información de la organización.
 */
import type { OrganizationDto } from "common/models";
import { useQuery, UseQueryResult } from "react-query";
import { config } from "common/config";
import { Queries } from "ui/query/queries";
import { organizationApi } from "../api/organizationApi";

export function useGetOrganizationInfo<TData = OrganizationDto>(
    options?: { enabled?: boolean }
): UseQueryResult<TData> {
    const organizationAddress = config.organization.address;
    return useQuery(
        [Queries.GET_ORGANIZATION_INFO, organizationAddress],
        async () => {
            const { data } = await organizationApi.get(organizationAddress);
            return data as TData;
        },
        options
    );
}
